import auth from '../authentication';
import Vue from '../main';

export default {
    getMapRedirect(context,data,callback){
        Vue.http.post(Vue.apiUrl + '/location/get-map', data, {
           
         }).then(response => {
            
            context.success = true;
            context.error = false;
             context.points = response.data.data;
            // context.total = response.data.total;
            // context.message = response.data.message;
            callback(context);
        })
        .catch(response => {
            
            // context.error = true;
            // context.message = response.data.message;
            // context.total = 0;
            // callback(context);
        })
    },
    addPointsByPark(context, data, callback){
        Vue.http.post(Vue.apiUrl + '/park-location/import', data)
        .then(response => {
            context.success = true;
            context.error = false;
            // context.locations = response.data.data;
            // context.total = response.data.total;
            // context.message = response.data.message;
            callback(context);
        })
        .catch(response => {
            context.error = true;
            context.message = response.data.message;
            context.total = 0;
            callback(context);
        })
    },
    getLocationByPark(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/park-location/get-by-park', data)
            .then(response => {
                context.error = false;
                context.locations = response.data.data;
                context.total = response.data.total;
                context.message = response.data.message;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                context.total = 0;
                callback(context);
            })
    },
    getLocation(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/location/get-all', data)
            .then(response => {
                context.error = false;
                context.locations = response.data.data;
                context.total = response.data.total;
                context.message = response.data.message;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                context.total = 0;
                callback(context);
            })
    },
    getLocationDetail(context, id, callback) {
        Vue.http.post(Vue.apiUrl + '/park-location/get-detail/' + id)
            .then(response => {
                context.error = false;
                context.location = response.data.data;
                callback(context);
            })
            .catch(response => {
                console.log(response);
                context.error = true;
                context.message = response.data.message;
                callback(context);
            })
    },
    getLocationSelect(context, callback) {
        Vue.http.post(Vue.apiUrl + '/location/get-select')
            .then(response => {
                context.error = false;
                context.locations = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                callback(context);
            })
    },
    createLocation(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/park-location/add-new', data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.location = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data.message;
                callback(context);
            })
    },
    updateLocation(context, id, data, callback) {
        Vue.http.post(Vue.apiUrl + '/park-location/update-detail/' + id, data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.location = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data.message;
                callback(context);
            })
    },
    updateLocationOrder(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/park-location/update-location-order', data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.location = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data.message;
                callback(context);
            })
    },
    removeLocation(context, id, callback) {
        Vue.http.post(Vue.apiUrl + '/park-location/remove/' + id, {})
            .then(response => {
                context.error = false;
                context.success = true;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                callback(context);
            })
    }
};